<template>
  <div class="mobile-app-buttons">
    <a
      :href="appStoreUrl"
      :target="'_blank'"
    >
      <v-lazy-image
        class="logo"
        :src="appStore"
      />
    </a>

    <a
      :href="googlePlayStoreUrl"
      :target="'_blank'"
    >
      <v-lazy-image
        class="logo"
        :src="playStore"
      />
    </a>

  </div>
</template>

<script>
  import VLazyImage from 'v-lazy-image'
  import conf from 'conf'

  export default {
    name: "AppButtonsWidget",
    components: {
      VLazyImage
    },
    computed: {
      appStoreUrl () {
        return conf.appStoreUrl
      },
      googlePlayStoreUrl () {
        return conf.googlePlayStoreUrl
      },
      appStore () {
        return require('assets/images/download/appstore.svg')
      },
      playStore () {
        return require('assets/images/download/playstore.svg')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~assets/styles/common.scss";

  .mobile-app-buttons {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 15px;
  }

  a {
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }

  .logo {
    height: 40px;

    @include bp-mf-tablet {
      height: 50px;
    }
  }
</style>